import { StatusColor } from "~/constants/status"
import { cn } from "~/utils/helpers"

interface StatusBadgeProps {
  color: StatusColor
  text: string
}

/**
 * Coloured-dot row state — fine / reorder / stockout / draft / sent / etc.
 * For generic metadata pills use Badge.
 * Canonical intent: {@link ../design-system/intents.ts STATUS_BADGE_INTENT}.
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ color, text }) => {
  let colorClass = ""

  switch (color) {
    case StatusColor.Success:
      colorClass = "bg-badge-status-sqaure-success"
      break
    case StatusColor.Information:
      colorClass = "bg-badge-status-sqaure-information"
      break
    case StatusColor.Neutral:
      colorClass = "bg-badge-status-sqaure-neutral"
      break
    case StatusColor.Warning:
      colorClass = "bg-badge-status-sqaure-warning"
      break
    case StatusColor.Error:
      colorClass = "bg-badge-status-sqaure-error"
      break
  }

  return (
    <div
      className={cn(
        "bg-badge-neutral-bg border border-badge-neutral-border rounded-md flex flex-row items-center h-5 pl-0.5 w-fit truncate",
        text ? "pr-1.5" : "pr-0.5",
      )}
    >
      <div className="size-4 shrink-0 flex items-center justify-center">
        <div className={cn("size-2 rounded-[3px] border border-black-alpha-24", colorClass)} />
      </div>
      {text && <div className="label-sm text-badge-neutral-fg-text">{text}</div>}
    </div>
  )
}
